import { useWebsitePolicy } from './WebsitePolicyContext'

const CONTROLLING_POLICY_NAME = 'publish_document'


// A plan that allows zero published policies (the Duda CMP-only plan) has no
// policy features at all, the Cookie Policy included. A plan whose provisions
// leave out the count keeps its policy features, because a missing count is
// not a limit of zero.
//
export default function useArePoliciesAvailable() {
  const { getProvision } = useWebsitePolicy()

  const publishCount = getProvision(CONTROLLING_POLICY_NAME)?.config?.operation_count

  return ( publishCount !== 0 )
}
